const menu = () => `
<?xml version="1.0" encoding="UTF-8"?>
<svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com -->
    <title>Group 2</title>
    <desc>Created with Sketch.</desc>
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(0 5)">
        <g id="Icon/Hamburger-Closed" fill="#FFFFFF">
            <g id="Group-2">
                <rect id="top" x="0" y="0" width="20" height="2" rx="1"></rect>
                <rect id="bottom" x="0" y="8" width="20" height="2" rx="1"></rect>
            </g>
        </g>
    </g>
</svg>
`;

export default menu;
